(function () {
  var STORAGE_KEY = 'adult-extension_la-d-coupe.myshopify.com';
  var EXIT_URL = 'https://www.google.fr/';
  var STYLE_ID = 'vdll-agegate-runtime-fix';

  document.documentElement.classList.add('vdll-agegate-live');

  function accepted() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function setAccepted(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
    } catch (error) {}
  }

  function runtimeCss() {
    return [
      'html.vdll-agegate-live body.vdll-agegate-open::before,html.vdll-agegate-live body.vdll-agegate-accepted::before{content:none!important;display:none!important;position:static!important;inset:auto!important;width:auto!important;height:auto!important;background:none!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;z-index:auto!important;}',
      'html.vdll-agegate-live #popupModal.ageplus_popup_model,html.vdll-agegate-live #maskModal.ageplus_popup_model,html.vdll-agegate-live #horizontalModal.ageplus_popup_model,html.vdll-agegate-live .ageplus_popup_model:not(#vdll-agegate),html.vdll-agegate-live .ageplus_popup_overlay,html.vdll-agegate-live .ageplus_popup_model_overlay{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}',
      'html.vdll-agegate-live body.vdll-agegate-open{overflow:hidden!important;}',
      'html.vdll-agegate-live body.vdll-agegate-open #vdll-agegate{display:flex!important;}',
      'html.vdll-agegate-live body.vdll-agegate-accepted #vdll-agegate{display:none!important;}'
    ].join('\n');
  }

  function keepRuntimeCssLast() {
    var head = document.head || document.documentElement;
    var style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      style.type = 'text/css';
      style.textContent = runtimeCss();
    }
    if (style.parentNode !== head || head.lastElementChild !== style) {
      try { head.appendChild(style); } catch (error) {}
    }
  }

  function buildOverlay() {
    var existing = document.getElementById('vdll-agegate');
    if (existing) return existing;

    var overlay = document.createElement('div');
    overlay.id = 'vdll-agegate';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'vdll-agegate-title');
    overlay.innerHTML = [
      '<div id="vdll-agegate-card">',
      '  <div id="vdll-agegate-content">',
      '    <p id="vdll-agegate-kicker">Accès réservé aux majeurs</p>',
      '    <h2 id="vdll-agegate-title">Bienvenue à la Vinothèque du Léman</h2>',
      '    <p id="vdll-agegate-main">Notre site présente des vins et spiritueux. Pour continuer, merci de confirmer que vous avez 18 ans ou plus.</p>',
      '    <p id="vdll-agegate-legal">La vente d’alcool est interdite aux mineurs. L’abus d’alcool est dangereux pour la santé, à consommer avec modération.</p>',
      '    <div id="vdll-agegate-actions">',
      '      <button id="vdll-agegate-accept" type="button">J’ai 18 ans ou plus</button>',
      '      <a id="vdll-agegate-exit" href="' + EXIT_URL + '" rel="nofollow noopener">Quitter le site</a>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('');

    overlay.querySelector('#vdll-agegate-accept').addEventListener('click', function (event) {
      event.preventDefault();
      setAccepted(true);
      syncState();
    });

    overlay.querySelector('#vdll-agegate-exit').addEventListener('click', function (event) {
      event.preventDefault();
      setAccepted(false);
      window.location.replace(EXIT_URL);
    });

    (document.body || document.documentElement).appendChild(overlay);
    return overlay;
  }

  function hideNativeAgeCheckNodes() {
    ['popupModal', 'maskModal', 'horizontalModal'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function syncState() {
    keepRuntimeCssLast();
    hideNativeAgeCheckNodes();
    buildOverlay();

    var body = document.body;
    if (!body) return;

    if (accepted()) {
      body.classList.remove('vdll-agegate-open');
      body.classList.add('vdll-agegate-accepted');
    } else {
      body.classList.remove('vdll-agegate-accepted');
      body.classList.add('vdll-agegate-open');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncState);
  } else {
    syncState();
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      syncState();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

  window.vdllResetAgeGate = function () {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
    syncState();
  };
})();
